import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';

const BookingSuccess = () => {
  const location = useLocation();
  const { productName, calendlyUrl } = location.state || {};

  useEffect(() => {
    // Load Calendly widget script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Success Header */}
        <div className="text-center mb-8">
          <div className="mb-6">
            <svg className="w-24 h-24 text-green-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h1 className="text-4xl md:text-5xl font-black text-white mb-4">Payment Successful!</h1>
          <p className="text-xl text-gray-300 mb-2">
            Thank you for your purchase of <span className="text-blue-400 font-bold">{productName || 'your consultation'}</span>
          </p>
          <p className="text-lg text-gray-400">
            Now let's schedule your session
          </p>
        </div>

        {/* Calendly Embed */}
        {calendlyUrl ? (
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
            <div className="bg-gradient-to-r from-blue-600 to-green-600 p-4 text-center">
              <h2 className="text-2xl font-bold text-white">Choose Your Appointment Time</h2>
            </div>
            <div 
              className="calendly-inline-widget" 
              data-url={calendlyUrl}
              style={{ minWidth: '320px', height: '700px' }}
            ></div>
          </div>
        ) : (
          <div className="bg-white rounded-2xl shadow-2xl p-8 text-center">
            <p className="text-gray-700 mb-6">
              We'll send you an email shortly with instructions on how to schedule your session.
            </p>
            <Link
              to="/"
              className="inline-block bg-gradient-to-r from-blue-600 to-green-600 text-white px-8 py-3 rounded-full font-bold hover:from-blue-700 hover:to-green-700 transition-all"
            >
              Return to Home
            </Link>
          </div>
        )}

        {/* Footer Note */}
        <div className="text-center mt-8">
          <p className="text-gray-400 text-sm">
            You'll receive a confirmation email with your appointment details.
          </p>
          <Link
            to="/"
            className="inline-block text-blue-400 hover:text-blue-300 font-semibold mt-4"
          >
            ← Return to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BookingSuccess;
